<template>

    <div id="chat-input_Easy" ref="chatInputArea">

        <ConfirmPopup ></ConfirmPopup>

        <div v-if="selectedFile" class="selected-file">
            <img v-if="isImage(selectedFile)" :src="filePreview" alt="Image Preview" height="25px">
            <div>
                {{ selectedFile.name }}
            </div>
            <button @click="removeFile" class="icon-button">🗑️</button>
        </div>

        <div v-if="selectedUrl" class="selected-file">
            <img :src="selectedUrl" alt="Image Preview" height="25px">
            <button @click="selectedUrl = null" class="icon-button">🗑️</button>
        </div>
        


        <div v-if="showEmojiPicker" class="emoji-picker-container">
            <picker :data="emojiIndex" @select="addEmoji" :show-preview="false" :set="activeSet" />
        </div>
        <input type="file" id="sendFile_Easy" @change="fileSelected" hidden />


        <div class="input-box">
            <button @click="toggleEmojiPicker" class="icon-button">😊</button>

            <vue-tribute :options="options">
                <div contenteditable="true" class="editable" placeholder="@..." @keydown.enter.prevent="sendMessage"
                    @input="onInput" ref="messageInput">
                </div>
            </vue-tribute>


            <button @click="openFileSelecter" class="icon-button"><i class="pi pi-plus"></i></button>
            <button @click="sendMessage" class="icon-button"><i class="pi pi-send"></i></button>

        </div>


    </div>
</template>

<script>
import axios from 'axios';

import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { VueTribute } from 'vue-tribute'
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";


let emojiIndex = new EmojiIndex(data);

export default {
    props: ['chatType', 'users', 'blocks', 'active_page'],
    components: {
        Picker,
        VueTribute
    },
    data() {
        return {
            localActivePage: this.active_page,
            showEmojiPicker: false,
            emojiIndex: emojiIndex,
            message: '',
            activeSet: 'apple',
            selectedFile: null,
            filePreview: null,
            uploadPercentage: 0,
            lastTypingTime: 0,
            selectedUrl: null,
            options: {
                values: this.users,
                lookup: 'nickname',
                itemClass: 'mention-item',
                selectTemplate: function (item) {
                    if (typeof item === 'undefined') return null;
                    return `<span contenteditable="false" class="selected-mention" user-id="${item.original.user_id}">@${item.original.nickname}</span>&nbsp;`;
                },
                menuItemTemplate: function (item) {
                    return `@${item.original.nickname}`;
                }
            }
        };
    },
    methods: {
        fileSelected(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
                this.filePreview = URL.createObjectURL(file);
            }
            setTimeout(() => {
                this.$emit('resize-height');
            }, 50);
        },
        removeFile() {
            URL.revokeObjectURL(this.filePreview);
            this.filePreview = null;
            this.selectedFile = null;
            document.getElementById('sendFile_Easy').value = '';
            setTimeout(() => {
                this.$emit('resize-height');
            }, 50);
        },
        isImage(file) {
            return file.type.startsWith('image/');
        },
        toggleEmojiPicker() {
            this.showEmojiPicker = !this.showEmojiPicker;
        },
        addEmoji(emoji) {
            this.$refs.messageInput.focus();
            console.log(emoji);
            const sel = window.getSelection();
            if (!sel.rangeCount) return;

            const range = sel.getRangeAt(0);
            range.deleteContents();

            let style = `background-position: ${emoji.getPosition()}; background-image: url(https://unpkg.com/emoji-datasource-apple@15.0.1/img/apple/sheets-256/64.png); width: 16px; height: 16px; display: inline-block; background-size: 5700%;`;
            const emojiDiv = document.createElement('span');
            emojiDiv.setAttribute('class', 'emoji');
            emojiDiv.setAttribute('style', style);
            emojiDiv.setAttribute('contenteditable', 'false');

            const textNode = document.createTextNode(emoji.colons);
            const textContainer = document.createElement('span');
            textContainer.style.visibility = 'hidden';
            textContainer.appendChild(textNode);
            emojiDiv.appendChild(textContainer);

            range.insertNode(emojiDiv);

            range.setStartAfter(emojiDiv);
            range.setEndAfter(emojiDiv);

            const spaceNode = document.createTextNode('\u00A0');
            range.insertNode(spaceNode);

            range.setStartAfter(spaceNode);
            range.setEndAfter(spaceNode);

            sel.removeAllRanges();
            sel.addRange(range);

            this.showEmojiPicker = false;
        },
        async sendMessage(event) {
            if (event) {
                event.preventDefault();
            }
            const messageInput = this.$refs.messageInput;

            if (this.chatType && this.localActivePage) {
                const t_user_id = this.localActivePage.user_id
                if (this.blocks.find(c => c.target_id == t_user_id)) {


                    this.$confirm.require({
                        target: event.currentTarget,
                        message: this.$t('general_err.blocked'),
                        icon: 'pi pi-exclamation-triangle',
                        rejectProps: {
                            label: 'Cancel',
                            severity: 'secondary',
                            outlined: true
                        },
                        acceptProps: {
                            label: 'Unblock & Send'
                        },
                        accept: () => {
                            this.$socket.emit('block', {action: 'delete', target: t_user_id});
                            setTimeout(() => {
                                this.sendMessage(event)
                            }, 750);
                        },
                        reject: () => {
                            messageInput.innerHTML = '';
                        }
                    });
                    return;
                }

            }


            const fileInput = document.getElementById('sendFile_Easy');
            const file = fileInput.files[0];

            const processedMessage = this.extractEmojiText(messageInput.innerHTML);

            if (file) {
                const fileType = this.getFileType(file);
                try {
                    const formData = new FormData();
                    formData.append('file', file);
                    messageInput.innerHTML = '';
                    const response = await axios.post(this.$socket_url + '/upload', formData, {
                        headers: {
                            'Authorization': this.$socket.authKeyUnique.auth,
                            'User_ID': this.$socket.authKeyUnique.user_id
                        },
                        onUploadProgress: (progressEvent) => {
                            this.uploadPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        }
                    });

                    if (response.data.status) {
                        const messageData = {
                            message: processedMessage,
                            type: fileType,
                            url: response.data.path
                        };
                        messageInput.innerHTML = '';
                        this.$emit('send-message', messageData);

                    } else {
                        console.error('Dosya yükleme hatası:', response.data.error);
                    }
                } catch (error) {
                    console.error('Dosya yükleme sırasında bir hata oluştu:', error);
                }
                this.removeFile();
            } else if (processedMessage.trim() !== '') {

                var messageData = {
                    message: processedMessage,
                    type: 'text'
                };

                if (this.selectedUrl) {
                    messageData.imageUrl = this.selectedUrl;
                    messageData.type = 'image';
                }
                messageInput.innerHTML = '';
                this.selectedUrl = null;
                this.$emit('send-message', messageData);
            }
            if (this.chatType == false)
                this.$emit('typing', { typing: false });

            this.uploadPercentage = 0;
        },
        onInput() {
            if (this.chatType == true)
                return;
            const messageInput = this.$refs.messageInput;
            if (messageInput.innerText.length > 0) {
                const now = Date.now();
                if (now - this.lastTypingTime < 1000) {
                    return;
                }

                this.lastTypingTime = now;
                this.$emit('typing', { typing: true });
            }
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.showEmojiPicker = false;
            }
        },
        getFileType(file) {
            if (file.type.match('image.*')) {
                return 'image';
            } else if (file.type.match('video.*')) {
                return 'video';
            } else if (file.type.match('audio.*')) {
                return 'audio';
            } else {
                return 'file';
            }
        },
        openFileSelecter() {
            const fileInput = document.getElementById('sendFile_Easy');
            fileInput.click();
        },
        extractEmojiText(htmlContent) {
            const container = document.createElement('div');
            container.innerHTML = htmlContent;

            // Emojileri işle
            const emojis = container.querySelectorAll('.emoji');
            emojis.forEach(emoji => {
                const emojiText = emoji.dataset.colons;
                if (emojiText) {
                    const textNode = document.createTextNode(emojiText);
                    emoji.parentNode.replaceChild(textNode, emoji);
                }
            });

            // Mentionları işle
            const mentions = container.querySelectorAll('.selected-mention');
            mentions.forEach(mention => {
                const mentionText = `\u2985${mention.textContent},${mention.getAttribute('user-id') ? mention.getAttribute('user-id') : '0'}\u2986`;
                const textNode = document.createTextNode(mentionText);
                mention.parentNode.replaceChild(textNode, mention);
            });

            return container.innerText;
        },
        getHeight() {
            return this.$el.offsetHeight;
        },
        addImageToMessage(event) {
            const data = event.data;
            if (data.type === 'selected-iframe-image') {
                this.selectedUrl = data.url;
            }
        }


    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        window.addEventListener('message', this.addImageToMessage);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('message', this.addImageToMessage);
    },
    watch: {
        '$refs.chatInputArea.offsetHeight': function (newHeight, oldHeight) {
            if (newHeight !== oldHeight) {
                console.log('resizing');
                this.$emit('resize-height', newHeight);
            }
        },
        users(newValue) {
            this.options.values = newValue;
        },
        active_page(newValue) {
            this.localActivePage = newValue;
        }
    }
};
</script>

<style scoped>
.emoji-picker-container {
    position: absolute;
    bottom: 50px;
    z-index: 1000;
}

#chat-input_Easy {
    background-color: var(--p-neutral-0);
    color: rgb(0, 0, 0);
    display: flex;
    flex-direction: column;
    margin: 6px;
    border-radius: 6px;
    padding: 6px;

}


#chat-input_Easy .input-box,
#chat-input_Easy .selected-file {
    display: flex;
    align-items: center;
    flex-direction: row;
}

#chat-input_Easy .sendInput {
    flex-grow: 1;
    border: 1px solid var(--p-neutral-100);
    padding: 6px;
    border-radius: 4px;
    outline: none;
    resize: none;
}

#chat-input_Easy .icon-button {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

#chat-input_Easy .icon-button svg,
.icon-button i {
    width: 24px;
    height: 24px;
    line-height: 24px;
}

#sendFile_Easy {
    display: none;
}


.editable {
    min-height: 20px;
    padding: 8px;
    border: 1px solid var(--p-neutral-300);
    border-radius: 4px;
    outline: none;
    width: 100%;
    color: var(--p-neutral-900);
    display: flex;
}

.editable:focus {
    border-color: #66afe9;
}

.editable.empty::before {
    content: attr('placeholder');
    color: #999;
}

.emoji span {
    display: none;
}

span.selected-mention {
    color: blue;
    font-weight: 500;
}
</style>
